import { Text } from "@chakra-ui/react"

import TransactionRejected from "#/shared/components/TransactionRejected"
import { useLoginAndFetchAccount } from "#/shared/hooks"
import { ConnectionStatus } from "#/shared/types"

type ConnectWalletStatusTextProps = {
  onClick?: () => void
  hasError: boolean
  status: ConnectionStatus
}

const statusColor = {
  idle: "primary.black.30",
  pending: "primary.red.100",
  done: "primary.black.100",
  error: "primary.red.100",
}

export function ConnectWalletConnectionStatus({
  onClick,
  hasError,
  status,
}: ConnectWalletStatusTextProps) {
  if (hasError) {
    return (
      <TransactionRejected
        showIcon={false}
        onClick={onClick}
        textProps={{ color: statusColor.error, pt: "2px" }}
      />
    )
  }

  return (
    <Text
      fontWeight={500}
      fontSize="16px"
      lineHeight="24px"
      letterSpacing="0.16px"
      color={statusColor[status]}
    >
      Connect wallet
    </Text>
  )
}

export function ConnectWalletSignatureStatus({
  hasError,
  status,
}: Omit<ConnectWalletStatusTextProps, "onClick">) {
  const { loginAndFetchAccount } = useLoginAndFetchAccount()

  if (hasError) {
    return (
      <TransactionRejected
        showIcon={false}
        onClick={loginAndFetchAccount}
        textProps={{ color: statusColor.error, pt: "2px" }}
      />
    )
  }

  return (
    <Text
      fontWeight={500}
      fontSize="16px"
      lineHeight="24px"
      letterSpacing="0.16px"
      color={statusColor[status]}
    >
      Sign message
    </Text>
  )
}
